import React from "react";
import contextProvider from "app/contextProvider";
import { withRouter, Link } from "react-router-dom";
import { Row, Col } from "reactstrap";

import _ReactOBaseComponent from "app/_L0_components/_ReactOBaseComponent";
import { _LoadingWrapper } from "app/_L0_components/Widgets/_LoadingKit";

import Section from "app/_L1_components/Layout/Section";
import Panel from "app/_L1_components/Layout/Panel";
import ReactOForm from "app/_L1_components/Elements/ReactOForm";
import ReactOFormInput from "app/_L1_components/Elements/ReactOFormInput";
import ReactOButton from "app/_L1_components/Elements/ReactOButton";
import ReactOCollapse from "app/_L1_components/Elements/ReactOCollapse";
import ReactOTooltip from "app/_L1_components/Elements/ReactOTooltip";
import ReactOActionBar from "app/_L1_components/Elements/ReactOActionBar";
import RowSpanTable from "../Elements/RowSpanTable";

import ReactOTable from "app/_L1_components/Elements/ReactOTable";
import ReactOModal from "app/_L1_components/Elements/ReactOModal";

class ProbConf2 extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: false,
      data: null,
      noLog: null,
    };
    super(props, initState);
    this.apiStore = null;
    this.actionsShelf = null;
    this._REFRESH_TOUT = null;
    // this._LOADING_ENABLED = true;
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    //		console.log("DEBUG :: Account _ onComponentDidMount");
    this.apiStore = this.getAppContext().getApiStoreService();
    this.actionsShelf = this.getAppContext().getActionsShelfService();
    if (this.getAppContext().getLocalStorageService().isSet("sd_log_view")) {
      this.getAppContext().getLocalStorageService().remove("sd_log_view");
    }
    this.loadSuggestions();
  }

  onComponentWillUnmount() {}

  loadSuggestions(cb) {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.apiStore.fire("load_suggestions", {
          ___onSuccess: (status, data) => {
            let countYES = 0;
            let countNO = 0;
            Object.keys(data.confs).forEach((a, b) => {
              if (data.confs[a].mod == "yes") {
                countYES = countYES + 1;
              } else {
                countNO = countNO + 1;
              }
            });

            if (countYES == 0) {
              this.setState({
                data: data,
                countYES: countYES,
                countNO: countNO,
              });

              this._view_form.init();
              this._view_form.submit();
            } else {
              this.setState({
                data: data,
                countYES: countYES,
                countNO: countNO,
                loading: false,
              });
            }
          },
        });
      }
    );
  }

  _makeid() {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < 6; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    return text;
  }

  loadLog(data) {
    let from_ts = this.getAppContext().momentjs().unix() - data.view_preset;
    let to_ts = this.getAppContext().momentjs().unix();

    this.setState(
      {
        loading: true,
      },
      this.apiStore.fire("sdlog", {
        data: {
          from_ts: from_ts,
          to_ts: to_ts,
        },
        ___onSuccess: (status, data_log) => {
          if (Object.keys(data_log.log).length == 0) {
            this.setState({ noLog: data.name_preset, loading: false });
          } else {
            this.setState({ noLog: null });
            this.formatLog(data_log);
          }
        },
      })
    );
  }

  formatLog = (data) => {
    this.rowSpanTime = new Map();
    this.rowClass = new Map();
    // clone partial obj

    let clone = {};

    Object.keys(data.log)
      .reverse()
      .forEach((time) => {
        clone = {
          ...clone,
          [time]: {},
        };
        Object.keys(data.log[time])
          .sort()
          .forEach((probeid) => {
            clone[time] = {
              ...clone[time],
              [probeid]: { operations: [], name: data.log[time][probeid].name },
            };
          });
      });

    // Counter
    Object.keys(data.log)
      .sort()
      .forEach((time, id) => {
        let spanRow = 0;

        Object.keys(data.log[time])
          .sort()
          .forEach((probeid) => {
            let spanRow_probe_add = 0;
            let spanRow_probe_del = 0;
            let isAdd = false;
            let isDel = false;
            let _referenceAdd = {};
            let _referenceDel = {};

            let operation_add = {
              action: { text: "(+)", className: "ap-green" },
              reason: "Automatic on better RSSI",
              aps: null,
            };

            let operation_del = {
              action: { text: "(-)", className: "ap-red" },
              reason: "Automatic on reduced RSSI",
            };

            Object.keys(data.log[time][probeid].essids)
              .sort()
              .forEach((essid) => {
                if (data.log[time][probeid].essids[essid].ADD.length > 0) {
                  let _add = data.log[time][probeid].essids[essid].ADD;
                  isAdd = true;
                  operation_add._id = this._makeid();
                  _add.forEach((mac) => {
                    if (mac == "Top3") {
                      operation_add.aps = {
                        ...operation_add.aps,
                        Top3: { Top3: "Top3" },
                      };
                    } else if (
                      data.ap_names[mac.substring(0, mac.length - 1)] == undefined &&
                      data.ap_names[mac] == undefined
                    ) {
                      operation_add.aps = {
                        ...operation_add.aps,
                        [mac]: {},
                      };

                      _referenceAdd = {
                        ..._referenceAdd,
                        [mac]: essid,
                      };
                    } else if (
                      data.ap_names[mac.substring(0, mac.length - 1)] != undefined &&
                      data.ap_names[mac] == undefined
                    ) {
                      operation_add.aps = {
                        ...operation_add.aps,
                        [data.ap_names[mac.substring(0, mac.length - 1)]]: {},
                      };

                      _referenceAdd = {
                        ..._referenceAdd,
                        [mac]: essid,
                      };
                    } else if (
                      data.ap_names[mac.substring(0, mac.length - 1)] == undefined &&
                      data.ap_names[mac] != undefined
                    ) {
                      operation_add.aps = {
                        ...operation_add.aps,
                        [data.ap_names[mac]]: {},
                      };

                      _referenceAdd = {
                        ..._referenceAdd,
                        [mac]: essid,
                      };
                    }
                  });
                }

                if (data.log[time][probeid].essids[essid].DEL.length > 0) {
                  let _del = data.log[time][probeid].essids[essid].DEL;
                  isDel = true;
                  operation_del._id = this._makeid();
                  _del.forEach((mac) => {
                    if (mac == "Top3") {
                      operation_del.aps = {
                        ...operation_del.aps,
                        Top3: { Top3: "Top3" },
                      };
                    } else if (
                      data.ap_names[mac.substring(0, mac.length - 1)] == undefined &&
                      data.ap_names[mac] == undefined
                    ) {
                      operation_del.aps = {
                        ...operation_del.aps,
                        [mac]: {},
                      };

                      _referenceDel = {
                        ..._referenceDel,
                        [mac]: essid,
                      };
                    } else if (
                      data.ap_names[mac.substring(0, mac.length - 1)] != undefined &&
                      data.ap_names[mac] == undefined
                    ) {
                      operation_del.aps = {
                        ...operation_del.aps,
                        [data.ap_names[mac.substring(0, mac.length - 1)]]: {},
                      };

                      _referenceDel = {
                        ..._referenceDel,
                        [mac]: essid,
                      };
                    } else if (
                      data.ap_names[mac.substring(0, mac.length - 1)] == undefined &&
                      data.ap_names[mac] != undefined
                    ) {
                      operation_del.aps = {
                        ...operation_del.aps,
                        [data.ap_names[mac]]: {},
                      };

                      _referenceDel = {
                        ..._referenceDel,
                        [mac]: essid,
                      };
                    }
                  });
                }
              });

            Object.keys(data.log[time][probeid].essids)
              .sort()
              .forEach((essid) => {
                if (data.log[time][probeid].essids[essid].ADD.length > 0) {
                  let _add = data.log[time][probeid].essids[essid].ADD;
                  _add.forEach((mac) => {
                    if (
                      mac != "Top3" &&
                      data.ap_names[mac.substring(0, mac.length - 1)] != undefined &&
                      data.ap_names[mac] == undefined
                    ) {
                      operation_add.aps[
                        data.ap_names[mac.substring(0, mac.length - 1)]
                      ] = _referenceAdd;
                    } else if (
                      mac != "Top3" &&
                      data.ap_names[mac.substring(0, mac.length - 1)] == undefined &&
                      data.ap_names[mac] != undefined
                    ) {
                      operation_add.aps[data.ap_names[mac]] = _referenceAdd;
                    } else if (
                      mac != "Top3" &&
                      data.ap_names[mac.substring(0, mac.length - 1)] == undefined &&
                      data.ap_names[mac] == undefined
                    ) {
                      operation_add.aps[mac] = _referenceAdd;
                    }
                  });
                }

                if (data.log[time][probeid].essids[essid].DEL.length > 0) {
                  let _del = data.log[time][probeid].essids[essid].DEL;
                  _del.forEach((mac) => {
                    if (
                      mac != "Top3" &&
                      data.ap_names[mac.substring(0, mac.length - 1)] != undefined &&
                      data.ap_names[mac] == undefined
                    ) {
                      operation_del.aps[
                        data.ap_names[mac.substring(0, mac.length - 1)]
                      ] = _referenceDel;
                    } else if (
                      mac != "Top3" &&
                      data.ap_names[mac.substring(0, mac.length - 1)] == undefined &&
                      data.ap_names[mac] != undefined
                    ) {
                      operation_del.aps[data.ap_names[mac]] = _referenceDel;
                    } else if (
                      mac != "Top3" &&
                      data.ap_names[mac.substring(0, mac.length - 1)] == undefined &&
                      data.ap_names[mac] == undefined
                    ) {
                      operation_del.aps[mac] = _referenceDel;
                    }
                  });
                }
              });

            if (isAdd == true) {
              spanRow += 1;
              spanRow_probe_add += 1;
              clone[time][probeid].operations.push(operation_add);
            }
            if (isDel == true) {
              spanRow += 1;
              spanRow_probe_del += 1;
              clone[time][probeid].operations.push(operation_del);
            }
            // this.rowSpanProbe.set(clone[time][probeid], spanRow_probe);
            clone[time][probeid].rowspan = spanRow_probe_add + spanRow_probe_del;
          });
        this.rowSpanTime.set(time, spanRow);

        if (id % 2 != 0) {
          this.rowClass.set(time, "row-stripe-table");
        } else {
          this.rowClass.set(time, "");
        }
      });

    this.setState({
      loading: false,
      dataLog: clone,
    });
  };

  submitSuggestions(data, cb) {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.apiStore.fire("sd_confs", {
          data: {
            value: data.value,
            probeuid: data.probeuid,
          },
          ___onSuccess: (response_status, response_data) => {
            this.loadSuggestions();
            if (cb) cb(response_status, response_data[0]);
          },
        });
      }
    );
  }

  onRender() {
    return (
      <Section
        designType="narrow"
        className={this.getAppContext().media.isMobile ? "mt-1" : "mt-3"}
      >
        <_LoadingWrapper loadingPlug={this.state.loading}>
          {this.getAppContext().media.isMobile ? (
            <div className="mx-1">
              <div className="d-flex">
                <div className="flex-shrink-1 mr-3" style={{ fontSize: "40px" }}>
                  <div style={{ display: "inline-block" }}>
                    <span className="icon-settings"></span>
                  </div>
                  <div style={{ display: "inline-block" }}>
                    <h5 className="ml-2">Software Defined configuration</h5>
                  </div>
                </div>
              </div>
              <div
                className={this.getAppContext().media.isMobile ? "py-2" : "ml-auto p-2"}
              >
                <small className="text-muted">
                  Last scan at:{" "}
                  <strong>
                    {this.state.data && this.state.data.last_update
                      ? this.getAppContext()
                          .momentjs(this.state.data.last_update, "X")
                          .format("L LTS")
                      : "-"}
                  </strong>
                </small>
              </div>
              <div
                className={this.getAppContext().media.isMobile ? "py-2" : "d-flex mb-3"}
              >
                <h5 className="pt-2">Probes with changes on AP assignments</h5>
              </div>
            </div>
          ) : (
            <div>
              <div className="d-flex py-1">
                <div className="flex-shrink-1 mr-3" style={{ fontSize: "40px" }}>
                  <div style={{ display: "inline-block" }}>
                    <span style={{ fontSize: "1.5rem" }} className="icon-settings"></span>
                  </div>
                  <div style={{ display: "inline-block" }}>
                    <h4 className="ml-2">Software Defined configuration</h4>
                  </div>
                </div>
              </div>
              <div className="d-flex mb-3">
                <h5 className="pt-2">Probes with changes on AP assignments</h5>
                <div className="ml-auto p-2">
                  <small className="text-muted">
                    Last scan at:{" "}
                    <strong>
                      {this.state.data && this.state.data.last_update
                        ? this.getAppContext()
                            .momentjs(this.state.data.last_update, "X")
                            .format("L LTS")
                        : "-"}
                    </strong>
                  </small>
                </div>
              </div>
            </div>
          )}

          {this.state.data && this.state.countYES == 0 ? (
            <Panel
              className={this.getAppContext().media.isMobile ? "mx-1" : "mb-4"}
              bodyClassName="p-0"
              rounded
            >
              <div
                className="notdep-bg"
                onClick={() => {
                  this._advanced_collapse.toggle();
                }}
              >
                <div className="py-2">
                  <Col xs={12}>
                    <Row
                      noGutters
                      style={
                        this.getAppContext().media.isMobile ? { display: "block" } : null
                      }
                    >
                      {this.getAppContext().media.isMobile ? (
                        <span className="">Nothing to change now</span>
                      ) : null}
                      <div className="d-flex flex-grow-1">
                        <div className="flex-grow-1">
                          {this.getAppContext().media.isMobile ? (
                            <span className="sub-title">Log of past changes</span>
                          ) : (
                            <span>Nothing to change now</span>
                          )}
                        </div>
                        <div className="justify-content-end">
                          <strong>
                            {this.getAppContext().media.isMobile
                              ? null
                              : "Log of past changes"}
                            <span
                              className={
                                this.state._advanced_collapse_opened == false
                                  ? "icon-caret-down-outline"
                                  : "icon-caret-up-outline"
                              }
                            ></span>
                          </strong>
                        </div>
                      </div>
                    </Row>
                  </Col>
                </div>
              </div>

              <ReactOCollapse
                className="border-top border-2"
                onControllerReady={(_collapse_controller) => {
                  this._advanced_collapse = _collapse_controller;
                  this.setState({ _advanced_collapse_opened: false });
                }}
                onOpened={() => {
                  this.setState({ _advanced_collapse_opened: true });
                }}
                onClosed={() => {
                  this.setState({ _advanced_collapse_opened: false });
                }}
                initOpen={false}
              >
                <div>
                  <div className="pl-2 py-3">
                    <ReactOForm
                      onControllerReady={(form_controller) => {
                        this._view_form = form_controller;
                      }}
                      onSubmit={(data) => {
                        this.loadLog(data);
                      }}
                    >
                      <ReactOActionBar padding="0" alignV="start">
                        <ReactOFormInput
                          type="hidden"
                          data_key="is_preset"
                          default={"yes"}
                        />

                        <ReactOFormInput
                          type="hidden"
                          data_key="name_preset"
                          default={"Last 24 hours"}
                        />

                        <ReactOFormInput
                          type="select"
                          data_key="view_preset"
                          color="primary"
                          nomarg
                          size="sm"
                          default={3600 * 24}
                          onOptionSelect={(form_ctrl, selected_value, selected_name) => {
                            form_ctrl.handleFormChange("view_preset", selected_value);
                            form_ctrl.handleFormChange("name_preset", selected_name);
                            form_ctrl.handleFormChange("is_preset", "yes");
                            form_ctrl.submit();
                          }}
                          options={[
                            { name: "Last 24 hours", value: 3600 * 24 },
                            { name: "Last 7 days", value: 3600 * 24 * 7 },
                            { name: "Last 4 weeks", value: 3600 * 24 * 7 * 4 },
                          ]}
                        />
                      </ReactOActionBar>
                    </ReactOForm>
                  </div>

                  {this.state.dataLog && this.state.noLog == null ? (
                    <div>
                      <RowSpanTable
                        cols={[
                          {
                            title: "Time",
                            data_key: "timestamp",
                            align: "center",
                            width: "10",
                          },
                          {
                            title: "Probe",
                            data_key: "probe",
                            align: "center",
                            width: "15",
                          },
                          {
                            title: "Reason",
                            data_key: "reason",
                            align: "center",
                            width: "10",
                          },
                          {
                            title: "APs",
                            data_key: "aps",
                            align: "center",
                            width: "15",
                          },
                        ]}
                        rowSpan={this.rowSpanTime}
                        rowClass={this.rowClass}
                        data={this.state.dataLog}
                      />
                    </div>
                  ) : (
                    <div className="px-3 pb-3">
                      <strong>No changes in {this.state.noLog}</strong>
                    </div>
                  )}
                </div>
              </ReactOCollapse>
            </Panel>
          ) : this.state.data && this.state.countYES > 0 ? (
            <Panel bodyClassName="p-0" rounded>
              <ReactOTable
                thClassName="px-3 py-1"
                tdClassName="align-middle px-3 py-2"
                compressed={
                  this.getAppContext().media.isMobile ||
                  this.getAppContext().media.isTablet
                }
                compressedRowRendering={(row_items) => {
                  return (
                    <div>
                      <div className="mt-2">
                        <div className="text-muted">
                          <small className="">
                            <strong>{row_items.probes.title}</strong>
                          </small>
                        </div>
                        {row_items.probes.content}
                      </div>
                      <div className="mt-2">
                        <div className="text-muted">
                          <small className="">
                            <strong>{row_items.test.title}</strong>
                          </small>
                        </div>
                        {row_items.test.content}
                      </div>
                      <div className="mt-2">
                        <div className="text-muted">
                          <small className="">
                            <strong>{row_items.suggestions.title}</strong>
                          </small>
                        </div>
                        {row_items.suggestions.content}
                      </div>
                    </div>
                  );
                }}
                thDividers
                cols={[
                  {
                    title: "Probes",
                    data_key: "probes",
                    align: "center",
                    width: "40",
                    sortable: true,
                  },
                  {
                    title: "Access Points",
                    data_key: "test",
                    align: "center",
                    width: "40",
                    sortable: true,
                  },
                  {
                    title: "Actions",
                    data_key: "suggestions",
                    align: "center",
                    width: "15",
                  },
                ]}
                defaultSort={[
                  {
                    data_key: "probes",
                    order: "asc",
                  },
                  {
                    data_key: "test",
                    order: "asc",
                  },
                ]}
                rows={(() => {
                  let _TMP = [];
                  let count_id = 0;
                  Object.keys(this.state.data.confs).forEach((_CURR_key, _CURR_idx) => {
                    let renderList = {};
                    let render = [];
                    if (this.state.data.confs[_CURR_key].mod == "yes") {
                      Object.keys(this.state.data.confs[_CURR_key].show.add).forEach(
                        (_Curr0, _Id) => {
                          if (
                            this.state.data.confs[_CURR_key].show.APs[_Curr0] ||
                            this.state.data.confs[_CURR_key].show.del[_Curr0]
                          ) {
                            renderList = {
                              ...renderList,
                              [_Curr0]: "blue",
                            };
                          } else {
                            renderList = {
                              ...renderList,
                              [_Curr0]: "green",
                            };
                          }
                        }
                      );

                      Object.keys(this.state.data.confs[_CURR_key].show.APs).forEach(
                        (_Curr0, _Id) => {
                          if (
                            this.state.data.confs[_CURR_key].show.add[_Curr0] ||
                            this.state.data.confs[_CURR_key].show.del[_Curr0]
                          ) {
                            renderList = {
                              ...renderList,
                              [_Curr0]: "blue",
                            };
                          } else {
                            renderList = {
                              ...renderList,
                              [_Curr0]: "grey",
                            };
                          }
                        }
                      );

                      Object.keys(this.state.data.confs[_CURR_key].show.del).forEach(
                        (_Curr0, _Id) => {
                          if (
                            this.state.data.confs[_CURR_key].show.APs[_Curr0] ||
                            this.state.data.confs[_CURR_key].show.add[_Curr0]
                          ) {
                            renderList = {
                              ...renderList,
                              [_Curr0]: "blue",
                            };
                          } else {
                            renderList = {
                              ...renderList,
                              [_Curr0]: "red",
                            };
                          }
                        }
                      );
                      let id_tooltip;
                      Object.keys(renderList)
                        .sort()
                        .forEach((a, b) => {
                          count_id = count_id + 1;
                          id_tooltip =
                            "_tp_" +
                            a.substring(0, 12).replace(/[^0-9a-z]/gi, "") +
                            "_" +
                            count_id;
                          render.push(
                            <span
                              id={id_tooltip}
                              key={b}
                              className={"ap-" + renderList[a]}
                            >
                              {a.substring(0, 3) == "Top" ? a + " criteria" : a}{" "}
                              {renderList[a] == "red"
                                ? "(-)"
                                : renderList[a] == "green"
                                ? "(+)"
                                : renderList[a] == "blue"
                                ? "(Δ)"
                                : null}
                              <span>
                                {renderList[a] == "red" ||
                                renderList[a] == "green" ||
                                renderList[a] == "blue" ? (
                                  <ReactOTooltip
                                    placement="left"
                                    target={id_tooltip}
                                    text={
                                      renderList[a] == "red"
                                        ? a.substring(0, 3) == "Top"
                                          ? "Remove " + a
                                          : "Remove AP " + a
                                        : renderList[a] == "green"
                                        ? "Add AP " + a
                                        : renderList[a] == "blue"
                                        ? "Modify BSSID list for AP " + a
                                        : null
                                    }
                                  ></ReactOTooltip>
                                ) : null}
                              </span>
                              <br />
                            </span>
                          );
                        });

                      _TMP.push({
                        probes: {
                          value: this.state.data.confs[_CURR_key].probename,
                          render: (
                            <div>
                              <Link to={"/" + _CURR_key + "/active"} target="_blank">
                                <h5>{this.state.data.confs[_CURR_key].probename}</h5>
                                <span className="sub-title">
                                  {_CURR_key.replace(/(..)/g, "$1:").slice(0, -1)}
                                </span>
                              </Link>
                            </div>
                          ),
                        },
                        test: {
                          value: render,
                          render: <div>{render}</div>,
                        },
                        suggestions: {
                          value: "suggestions",
                          render: (
                            <div>
                              <Row>
                                <Col>
                                  <ReactOButton
                                    title="Modify"
                                    icon="pencil"
                                    color="gray200"
                                    size="sm"
                                    onClick={() => {
                                      this._set_modal.open(
                                        this.state.data.confs[_CURR_key]
                                      );
                                    }}
                                  />
                                </Col>
                              </Row>
                            </div>
                          ),
                        },
                      });
                    }
                  });
                  return _TMP;
                })()}
              />
            </Panel>
          ) : null}

          {this.state.data && this.state.countNO > 0 ? (
            <div
              className={this.getAppContext().media.isMobile ? "mt-1 mx-1" : "mt-3 pt-3"}
            >
              <div className="py-2">
                <h5 className="pt-2">Probes AP assignements</h5>
              </div>

              <Panel bodyClassName="p-0" rounded>
                <ReactOTable
                  thClassName="px-1 my-3 py-3"
                  tdClassName="align-middle px-3 py-2"
                  compressed={
                    this.getAppContext().media.isMobile ||
                    this.getAppContext().media.isTablet
                  }
                  compressedRowRendering={(row_items) => {
                    return (
                      <div>
                        <div className="mt-2">
                          <div className="text-muted">
                            <small className="">
                              <strong>{row_items.probes_of.title}</strong>
                            </small>
                          </div>
                          {row_items.probes_of.content}
                        </div>
                        <div className="mt-2">
                          <div className="text-muted">
                            <small className="">
                              <strong>{row_items.test_of.title}</strong>
                            </small>
                          </div>
                          {row_items.test_of.content}
                        </div>
                      </div>
                    );
                  }}
                  thDividers
                  cols={[
                    {
                      title: "Probes",
                      data_key: "probes_of",
                      align: "center",
                      width: "50",
                      sortable: true,
                    },
                    {
                      title: "Access Points",
                      data_key: "test_of",
                      align: "center",
                      width: "50",
                      sortable: true,
                    },
                  ]}
                  rows={(() => {
                    let _TMP = [];
                    Object.keys(this.state.data.confs).forEach((_CURR_key, _CURR_idx) => {
                      let apList = [];
                      if (this.state.data.confs[_CURR_key].mod == "no") {
                        Object.keys(this.state.data.confs[_CURR_key].show.APs)
                          .sort()
                          .forEach((_Curr0, _Id) => {
                            apList.push(
                              <span key={_Id} className="ap">
                                {_Curr0}
                                <br />
                              </span>
                            );
                          });

                        _TMP.push({
                          probes_of: {
                            value: this.state.data.confs[_CURR_key].probename,
                            render: (
                              <div>
                                <Link to={"/" + _CURR_key + "/active"} target="_blank">
                                  <h5>{this.state.data.confs[_CURR_key].probename}</h5>
                                  <span className="sub-title">
                                    {_CURR_key.replace(/(..)/g, "$1:").slice(0, -1)}
                                  </span>
                                </Link>
                              </div>
                            ),
                          },
                          test_of: {
                            value: "a",
                            render: <div>{apList}</div>,
                          },
                        });
                      }
                    });
                    return _TMP;
                  })()}
                />
              </Panel>
            </div>
          ) : null}

          {this.state.data &&
          this.state.data.old_only &&
          Object.keys(this.state.data.old_only).length > 0 ? (
            <div className="mt-3 pt-3">
              <div className="py-3">
                <h5 className="pt-2">Probes not considered</h5>
              </div>

              <Panel bodyClassName="p-0" rounded>
                <ReactOTable
                  thClassName="px-1 my-3 py-3"
                  tdClassName="align-middle px-3 py-2"
                  compressed={
                    this.getAppContext().media.isMobile ||
                    this.getAppContext().media.isTablet
                  }
                  compressedRowRendering={(row_items) => {
                    return (
                      <div>
                        <div className="mt-2">
                          <div className="text-muted">
                            <small className="">
                              <strong>{row_items.probes_old.title}</strong>
                            </small>
                          </div>
                          {row_items.probes_old.content}
                        </div>
                        <div className="mt-2">
                          <div className="text-muted">
                            <small className="">
                              <strong>{row_items.test_old.title}</strong>
                            </small>
                          </div>
                          {row_items.test_old.content}
                        </div>
                        <div className="mt-2">
                          <div className="text-muted">
                            <small className="">
                              <strong>{row_items.reset.title}</strong>
                            </small>
                          </div>
                          {row_items.reset.content}
                        </div>
                      </div>
                    );
                  }}
                  thDividers
                  cols={[
                    {
                      title: "Probes",
                      data_key: "probes_old",
                      align: "center",
                      width: "40",
                      sortable: true,
                    },
                    {
                      title: "Access Points",
                      data_key: "test_old",
                      align: "center",
                      width: "40",
                      sortable: true,
                    },
                    {
                      title: "Actions",
                      data_key: "reset",
                      align: "center",
                      width: "15",
                    },
                  ]}
                  defaultSort={[
                    {
                      data_key: "probes_old",
                      order: "asc",
                    },
                    {
                      data_key: "test_old",
                      order: "asc",
                    },
                  ]}
                  rows={(() => {
                    let _TMP = [];
                    Object.keys(this.state.data.old_only).forEach(
                      (_CURR_key, _CURR_idx) => {
                        let apList = [];

                        Object.keys(this.state.data.old_only[_CURR_key].show.APs)
                          .sort()
                          .forEach((_Curr0, _Id) => {
                            apList.push(
                              <span key={_Id} className="ap">
                                {_Curr0}
                                <br />
                              </span>
                            );
                          });

                        _TMP.push({
                          probes_old: {
                            value: this.state.data.old_only[_CURR_key].probename,
                            render: (
                              <div>
                                <Link to={"/" + _CURR_key + "/active"} target="_blank">
                                  <h5>
                                    {this.state.data.old_only[_CURR_key].probename}
                                    {this.state.data.old_only[_CURR_key].sync_status ==
                                    0 ? (
                                      <span className="text-danger inline-text">
                                        {" "}
                                        Offline
                                      </span>
                                    ) : null}
                                  </h5>
                                  <span className="sub-title">
                                    {_CURR_key.replace(/(..)/g, "$1:").slice(0, -1)}
                                  </span>
                                </Link>
                              </div>
                            ),
                          },
                          test_old: {
                            value: apList,
                            render: <div>{apList}</div>,
                          },
                          reset: {
                            value: "reset",
                            render: (
                              <div>
                                {this.state.data.old_only[_CURR_key].sync_status == 1 &&
                                !this.state.data.old_only[_CURR_key].show.APs.Top3 ? (
                                  <Row>
                                    <Col>
                                      <ReactOButton
                                        title="Modify"
                                        icon="pencil"
                                        color="gray200"
                                        size="sm"
                                        onClick={() => {
                                          this._reset_modal.open(
                                            this.state.data.old_only[_CURR_key]
                                          );
                                        }}
                                      />
                                    </Col>
                                  </Row>
                                ) : (
                                  <span>No actions for this probe</span>
                                )}
                              </div>
                            ),
                          },
                        });
                      }
                    );
                    return _TMP;
                  })()}
                />
              </Panel>
            </div>
          ) : null}

          <ReactOModal
            modalId="confSetting"
            size="lg"
            onControllerReady={(modal_context) => {
              this._set_modal = modal_context;
            }}
            onModalMounted={(data) => {
              this._set_form.init(data);
            }}
            header="Changes to be applied"
            centered={true}
            body={(data) => {
              return (
                <div>
                  <_LoadingWrapper loadingPlug={this.state.loading}>
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <strong>{data.probename}</strong>
                        <div>
                          <div>{data.probeid.replace(/(..)/g, "$1:").slice(0, -1)}</div>
                        </div>
                      </div>
                    </div>

                    <ReactOForm
                      onControllerReady={(form_controller) => {
                        this._set_form = form_controller;
                      }}
                      onSubmit={(form_data, cb) => {
                        // console.log("form data" + JSON.stringify(form_data))
                        let _rawCssidList = [];
                        let objAPs = {};
                        let toSend = {
                          probeuid: form_data.probeid,
                          measure_conf: "SD",
                          value: [],
                        };

                        // ARRAY DI CSSID
                        Object.keys(this.state.data.measures).forEach((_val, _id) => {
                          _rawCssidList.push(_val);
                          objAPs = { ...objAPs, [_val]: [] };
                        });

                        // APS MERGE in objAPs
                        _rawCssidList.forEach((_cur, _idx) => {
                          let counter = [];
                          Object.keys(form_data.show.APs).forEach((_val, _id) => {
                            Object.keys(form_data.show.APs[_val]).forEach((_x, _y) => {
                              if (_cur == _x) {
                                counter = counter.concat(form_data.show.APs[_val][_x]);
                                objAPs = {
                                  ...objAPs,
                                  [_x]: counter,
                                };
                              }
                            });
                          });
                        });

                        // // ARRAY CON ADD / DEL
                        // Object.filter = (obj, predicate) =>
                        //   Object.keys(obj)
                        //     .filter((key) => predicate(key))
                        //     .reduce((res, key) => ((res[key] = obj[key]), res), {});

                        // comma separator FIX
                        Object.filter = (obj, predicate) =>
                          Object.keys(obj)
                            .filter((key) => predicate(key))
                            .reduce(
                              (res, key) => Object.assign(res, { [key]: obj[key] }),
                              {}
                            );

                        let _raw_ADD = Object.values(
                          Object.filter(
                            form_data,
                            (score) => score.substring(0, 4) == "ADD_"
                          )
                        );
                        let _raw_DEL = Object.values(
                          Object.filter(
                            form_data,
                            (score) => score.substring(0, 4) == "DEL_"
                          )
                        );

                        _raw_ADD.forEach((cur, id) => {
                          _rawCssidList.forEach((val, id) => {
                            if (form_data.show.add[cur][val] != null)
                              objAPs[val] = objAPs[val].concat(
                                form_data.show.add[cur][val]
                              );
                          });
                        });

                        // DEL MERGE in objAPs- controllo se il valore da eliminare non è presente nei selezionati
                        Object.keys(form_data.show.del).forEach((val, b) => {
                          if (_raw_DEL.indexOf(val) == -1) {
                            _rawCssidList.forEach((_cur, _idx) => {
                              let counter = [];
                              Object.keys(form_data.show.del[val]).forEach((_x, _y) => {
                                if (_cur == _x) {
                                  counter = counter.concat(form_data.show.del[val][_x]);
                                  objAPs[_cur] = objAPs[_cur].concat(counter);
                                }
                              });
                            });
                          }
                        });

                        // riduzione di objAPs, eliminando le chiavi con array vuoti
                        // Object.reduce = (obj, predicate) =>
                        //   Object.keys(obj)
                        //     .filter((key) => predicate(obj[key]))
                        //     .reduce((res, key) => ((res[key] = obj[key]), res), {});

                        // comma separator FIX

                        Object.reduce = (obj, predicate) =>
                          Object.keys(obj)
                            .filter((key) => predicate(key))
                            .reduce(
                              (res, key) => Object.assign(res, { [key]: obj[key] }),
                              {}
                            );

                        let _reduced = Object.keys(
                          Object.reduce(objAPs, (score) => score.length > 0)
                        );

                        // Formattazione oggetto da inviare
                        _reduced.forEach((_k, id) => {
                          Object.keys(objAPs).forEach((_curr, id) => {
                            if (_k == _curr) {
                              toSend.value.push({
                                cssid: _curr,
                                fields: { bssid: objAPs[_curr].join(" ") },
                              });
                            }
                          });
                        });

                        this.submitSuggestions(toSend, cb);
                      }}
                    >
                      <div className="mt-3">
                        <Panel bodyClassName="p-0" rounded bgColor>
                          <ReactOTable
                            size="sm"
                            cols={[
                              {
                                title: "OPERATION",
                                data_key: "type",
                                align: "center",
                                width: "15",
                              },
                              {
                                title: "Access Points",
                                data_key: "name",
                                align: "center",
                                width: "35",
                              },
                              {
                                data_key: "input",
                                align: "center",
                                width: "15",
                              },
                            ]}
                            compressed={
                              this.getAppContext().media.isMobile ||
                              this.getAppContext().media.isTablet
                            }
                            compressedRowRendering={(row_items) => {
                              return (
                                <div>
                                  <div className="mt-2">
                                    <div className="text-muted">
                                      <small className="">
                                        <strong>{row_items.type.title}</strong>
                                      </small>
                                    </div>
                                    {row_items.type.content}
                                  </div>
                                  <div className="mt-2">
                                    <div className="text-muted">
                                      <small className="">
                                        <strong>{row_items.name.title}</strong>
                                      </small>
                                    </div>
                                    {row_items.name.content}
                                  </div>
                                  <div className="mt-2">{row_items.input.content}</div>
                                </div>
                              );
                            }}
                            thDividers
                            rows={(() => {
                              let _TMP_LIST = [];
                              let k = 0;
                              Object.keys(data.show.add)
                                .sort()
                                .forEach((_add, _id) => {
                                  let objListAdd = {};
                                  let printAdd = [];
                                  Object.keys(data.show.add[_add])
                                    .sort()
                                    .forEach((_name, _k) => {
                                      objListAdd = {
                                        ...objListAdd,
                                        [this.state.data.measures[_name]]:
                                          data.show.add[_add][_name],
                                      };
                                    });

                                  Object.keys(objListAdd)
                                    .sort()
                                    .forEach((_val, _id) => {
                                      printAdd.push(
                                        <div key={_id}>
                                          {_val}: {objListAdd[_val].join(", ")}
                                        </div>
                                      );
                                    });

                                  k += 1;
                                  _TMP_LIST.push({
                                    type: {
                                      value: "add",
                                      render: (
                                        <div>
                                          <strong>ADD</strong>
                                        </div>
                                      ),
                                    },
                                    name: {
                                      value: Object.keys(_add),
                                      render: (
                                        <div>
                                          <a
                                            href={
                                              this.getAppContext().conf
                                                .BASENAME +
                                              "/" +
                                              data.probeid +
                                              "/active/"
                                            }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            <div>
                                              <strong>{_add}</strong>
                                            </div>
                                            {printAdd}
                                          </a>
                                        </div>
                                      ),
                                    },
                                    input: {
                                      value: k,
                                      render: (
                                        <div key={k} className="py-2">
                                          <ReactOFormInput
                                            type="checkbox"
                                            data_key={"ADD_" + k}
                                            size="md"
                                            switchOnValue={_add}
                                          />
                                        </div>
                                      ),
                                    },
                                  });
                                });

                              Object.keys(data.show.del)
                                .sort()
                                .forEach((_del, _id) => {
                                  let objListDel = {};
                                  let printDel = [];

                                  Object.keys(data.show.del[_del])
                                    .sort()
                                    .forEach((_name, _k) => {
                                      objListDel = {
                                        ...objListDel,
                                        [this.state.data.measures[_name]]:
                                          data.show.del[_del][_name],
                                      };
                                    });

                                  Object.keys(objListDel)
                                    .sort()
                                    .forEach((_val, _id) => {
                                      printDel.push(
                                        <div key={_id}>
                                          {_val}: {objListDel[_val]}
                                        </div>
                                      );
                                    });

                                  k += 1;
                                  _TMP_LIST.push({
                                    type: {
                                      value: "del",
                                      render: (
                                        <div>
                                          <span>
                                            <strong>REMOVE</strong>
                                          </span>
                                        </div>
                                      ),
                                    },
                                    name: {
                                      value: Object.keys(_del),
                                      render: (
                                        <div>
                                          <a
                                            href={
                                              this.getAppContext().conf
                                                .BASENAME +
                                              "/" +
                                              data.probeid +
                                              "/active/"
                                            }
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            <div>
                                              <strong>{_del}</strong>
                                            </div>
                                            {printDel}
                                          </a>
                                        </div>
                                      ),
                                    },
                                    input: {
                                      value: k,
                                      render: (
                                        <div key={k} className="py-2">
                                          <ReactOFormInput
                                            type="checkbox"
                                            data_key={"DEL_" + k}
                                            size="md"
                                            switchOnValue={_del}
                                          />
                                        </div>
                                      ),
                                    },
                                  });
                                });

                              return _TMP_LIST;
                            })()}
                          />
                        </Panel>
                      </div>
                    </ReactOForm>
                  </_LoadingWrapper>
                </div>
              );
            }}
            actions={[
              {
                text: "Cancel",
                color: "light",
                action: "close",
              },
              (data) => {
                return {
                  text: "Apply",
                  color: "primary",
                  // disabled: this.state.disableApply,
                  action: () => {
                    this._set_form.submit((submit_result) => {
                      if (submit_result.status === true) {
                        this._set_modal.close();
                      }
                    });
                  },
                };
              },
            ]}
          />

          {/* MODAL FOR RESET */}
          <ReactOModal
            modalId="confReset"
            size="lg"
            onControllerReady={(modal_context) => {
              this._reset_modal = modal_context;
            }}
            onModalMounted={(data) => {
              this._reset_form.init(data);
            }}
            header="Reset probe for new developement"
            centered={true}
            body={(data) => {
              return (
                <div>
                  <_LoadingWrapper loadingPlug={this.state.loading}>
                    <div className="d-flex">
                      <div className="flex-grow-1">
                        <strong>{data.probename}</strong>
                        <div>{data.probeid.replace(/(..)/g, "$1:").slice(0, -1)}</div>
                      </div>
                    </div>

                    <ReactOForm
                      onControllerReady={(form_controller) => {
                        this._reset_form = form_controller;
                      }}
                      onSubmit={(form_data, cb) => {
                        // console.log("form data" + JSON.stringify(form_data))
                        let cssidList = [];
                        let toSend = {
                          probeuid: form_data.probeid,
                          measure_conf: "manual",
                          value: [],
                        };

                        Object.keys(form_data.show.APs).forEach((_res, id) => {
                          Object.keys(form_data.show.APs[_res]).forEach((cssid, id) => {
                            if (cssidList.indexOf(cssid) == -1) {
                              cssidList.push(cssid);
                            }
                          });
                        });

                        cssidList.forEach((val, id) => {
                          toSend.value.push({
                            cssid: val,
                            fields: { bssid: "Top3" },
                          });
                        });

                        this.submitSuggestions(toSend, cb);
                      }}
                    >
                      <div className="mt-3">
                        <Panel bodyClassName="p-0" rounded bgColor>
                          <ReactOTable
                            size="sm"
                            cols={[
                              {
                                title: "OPERATION",
                                data_key: "type",
                                align: "center",
                                width: "15",
                              },
                              {
                                title: "Access Points",
                                data_key: "name",
                                align: "center",
                                width: "35",
                              },
                              {
                                data_key: "input",
                                align: "center",
                                width: "15",
                              },
                            ]}
                            compressed={
                              this.getAppContext().media.isMobile ||
                              this.getAppContext().media.isTablet
                            }
                            compressedRowRendering={(row_items) => {
                              return (
                                <div>
                                  <div className="mt-2">
                                    <div className="text-muted">
                                      <small className="">
                                        <strong>{row_items.type.title}</strong>
                                      </small>
                                    </div>
                                    {row_items.type.content}
                                  </div>
                                  <div className="mt-2">
                                    <div className="text-muted">
                                      <small className="">
                                        <strong>{row_items.name.title}</strong>
                                      </small>
                                    </div>
                                    {row_items.name.content}
                                  </div>
                                  <div className="mt-2">{row_items.input.content}</div>
                                </div>
                              );
                            }}
                            thDividers
                            rows={(() => {
                              let _TMP_LIST = [];
                              let k = 0;
                              let printReset = [];
                              Object.keys(data.show.APs).forEach((reset, id) => {
                                printReset.push(<div key={id}>{reset}</div>);
                              });

                              _TMP_LIST.push({
                                type: {
                                  value: "reset",
                                  render: (
                                    <div>
                                      <span>
                                        <strong>RESET</strong>
                                      </span>
                                    </div>
                                  ),
                                },
                                name: {
                                  value: k,
                                  render: (
                                    <div>
                                      <a
                                        href={
                                          this.getAppContext().conf.BASENAME +
                                          "/" +
                                          data.probeid +
                                          "/active/"
                                        }
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <div>{printReset}</div>
                                      </a>
                                    </div>
                                  ),
                                },
                                input: {
                                  value: k,
                                  render: (
                                    <div key={k} className="py-2">
                                      <ReactOFormInput
                                        type="checkbox"
                                        data_key={"RES_" + k}
                                        size="md"
                                        switchOnValue={data.probeid}
                                      />
                                    </div>
                                  ),
                                },
                              });

                              return _TMP_LIST;
                            })()}
                          />
                        </Panel>

                        <div className="pt-3">
                          <span>
                            <strong>
                              The probe will be set in maintenance mode with manual
                              measures (Top3)
                            </strong>
                          </span>
                        </div>
                      </div>
                    </ReactOForm>
                  </_LoadingWrapper>
                </div>
              );
            }}
            actions={[
              {
                text: "Cancel",
                color: "light",
                action: "close",
              },
              (data) => {
                return {
                  text: "Apply",
                  color: "primary",
                  // disabled: this.state.disableApply,
                  action: () => {
                    this._reset_form.submit((submit_result) => {
                      if (submit_result.status === true) {
                        this._reset_modal.close();
                      }
                    });
                  },
                };
              },
            ]}
          />
        </_LoadingWrapper>
      </Section>
    );
  }
}

export default contextProvider(withRouter(ProbConf2), {
  define: null,
});
